import React, { Component } from 'react';
import { observer } from 'mobx-react';
import userstore from '../store/user-store';
import { Button, Form, Input } from 'semantic-ui-react';
import eb from '../utils/EventBus';
import Select from 'react-select';
import { withRouter } from 'react-router-dom'


class UserCreate extends Component {

	constructor(props) {
    super(props);
     this.state= {value:'Select One'};
    }

	
	componentDidMount() {
		userstore.selectedUser = {};
	    userstore.loadAdm();
		userstore.loadSh();
		userstore.loadRvw();
		userstore.loadApp();
		userstore.loadOrgs();
		eb.on('user-created', () => this.props.history.push('/user'));
	}


    
	render() {
		const usr = userstore.selectedUser || {};
		 
		return (
			<div className="buyer-invoice">
				<div class="title">
					<h4 align="left">Create User</h4>
				</div>
				{(
					<Form>
						<Form.Field inline>
							<label>First Name</label>
							<Input className="w-100" value={usr.firstname || ''} onChange={(evt, { value }) => userstore.setFirstName(value)} />
						</Form.Field>

						<Form.Field inline>
							<label>Last Name</label>
							<Input  className="w-100" value={usr.lastname || ''} onChange={(evt, { value }) => userstore.setLastName(value)} />
						</Form.Field>

						<Form.Field inline>
							<label>Email Address</label>
							<Input  className="w-100" value={usr.email || ''} onChange={(evt, { value }) => userstore.setEmailAddress(value)} />
						</Form.Field>

						<Form.Field inline>
							<label>User Name</label>
							<Input  className="w-100" value={usr.username || ''} onChange={(evt, { value }) => userstore.setUsername(value)} />
						</Form.Field>

						<Form.Field inline>
							<label>Password</label>
							<Input  className="w-100" type="password" value={usr.password || ''} onChange={(evt, { value }) => userstore.setPassword(value)} />
						</Form.Field>


                        <Form.Field inline>
							<label >Work Phone#</label>
							<Input  className="w-100" value={usr.workphone || ''} onChange={(evt, { value }) => userstore.setWorkPhoneNumber(value)} />
						</Form.Field>

						<Form.Field inline>
							<label>Mobile Phone#</label>
							<Input  className="w-100" value={usr.mobilephone || ''} onChange={(evt, { value }) => userstore.setMobilePhoneNumber(value)} />
						</Form.Field>

						<Form.Field inline>
                           <label>Org Name</label>
                           <Select  value={userstore.selectedOrg}
                     				onChange={(selectedOrgOption) => userstore.setSelectedOrg(selectedOrgOption)}
                      				options={userstore.selectedOrgOption}
						   />			       	
						</Form.Field>


                        <Form.Field inline>
                           <label>Admin</label>
                           <Select  value={userstore.selectedAdm}
                     				onChange={(selectedAdmOption) => userstore.setSelectedAdm(selectedAdmOption)}
                      				options={userstore.selectedAdmOption}
						   />			       	
						</Form.Field>

						
						<Form.Field inline>
                           <label>Can be shared with</label>
                           <Select  value={userstore.selectedSh}
                     				onChange={(selectedShOption) => userstore.setSelectedSh(selectedShOption)}
                      				options={userstore.selectedShOption}
						   />			       	
						</Form.Field>

						<Form.Field inline>
                           <label>Reviewer</label>
                           <Select  value={userstore.selectedRvw}
                     				onChange={(selectedRvwOption) => userstore.setSelectedRvw(selectedRvwOption)}
                      				options={userstore.selectedRvwOption}
						   />		      	
						</Form.Field>

						<Form.Field inline>
                           <label>Approver</label>
                           <Select value={userstore.selectedApp}
                     			   onChange={(selectedAppOption) => userstore.setSelectedApp(selectedAppOption)}
                      			   options={userstore.selectedAppOption}
						   />		       
						</Form.Field>

						<Button class="save right"  primary onClick={userstore.creUser}> Save</Button>

					</Form>
				)}
				<div className="footer">
					
				</div>
			</div>
		);
	}
}


export default withRouter(observer(UserCreate));

/*

						<Form.Field inline>
                           <label>Admin</label>
                           <Select  value={userstore.selectedAdm}
                     				onChange={(selectedAdmOption) => userstore.setSelectedAdm(selectedAdmOption)}
                      				options={userstore.selectedAdmOption}
						   />			       	
						</Form.Field>

						
						<Form.Field inline>
                           <label>Can be shared with</label>
                           <Select  value={userstore.selectedSh}
                     				onChange={(selectedShOption) => userstore.setSelectedSh(selectedShOption)}
                      				options={userstore.selectedShOption}
						   />			       	
						</Form.Field>

						<Form.Field inline>
                           <label>Reviewer</label>
                           <select id = "dropdown" 
                                    value={userstore.selectedRvw}
                     				onChange={(selectedRvwOption) => userstore.setSelectedRvw(selectedRvwOption)}
                      				options={userstore.selectedRvwOption}
						   >		      
						   </select>	
						</Form.Field>

						<Form.Field inline>
                           <label>Approver</label>
                           <select id = "dropdown" 
                                   value={userstore.selectedApp}
                     			   onChange={(selectedAppOption) => userstore.setSelectedApp(selectedAppOption)}
                      			   options={userstore.selectedAppOption}
						   >		       
						   </select>	
						</Form.Field>

*/



// WEBPACK FOOTER //
// ./src/containers/UserCreate.js